import React, { useReducer } from 'react';
import ReactDOM from 'react-dom';
import qs from 'qs';

import AppContext from './context';
import {
  appReducer,
  SET_STEP,
  SET_PROGRESS,
  SET_DISPLAY_TEXT,
  SET_FILTERS,
  SET_RESULTS
} from './reducer';

import App from './App';

const FindAProgram = props => {
  const [state, dispatch] = useReducer(appReducer, {
    step: 1,
    progress: 1,
    displayText: {},
    filters: {
      group: '',
      family: '',
      grade: '',
      gender: ''
    },
    results: []
  });

  const getResults = () => {
    const params = qs.stringify(state.filters);

    fetch(`/find_a_program/get_programs.json?${params}`)
      .then(response => response.json())
      .then(data => {
        dispatch({ type: SET_RESULTS, results: data.results });
      })
      .catch(error => {
        console.error(error);
      })
  }

  const clearResults = () => {
    dispatch({ type: SET_RESULTS, results: [] });
  }

  const getDisplayText = () => {
    fetch(`/find_a_program.json`)
      .then(response => response.json())
      .then(data => {
        dispatch({ type: SET_DISPLAY_TEXT, displayText: data });
      })
      .catch(error => {
        console.error(error);
      });
  }

  const setStep = step => {
    dispatch({ type: SET_STEP, step });
  }

  const setProgress = progress => {
    dispatch({ type: SET_PROGRESS, progress });
  }

  const setFilters = filters => {
    dispatch({ type: SET_FILTERS, filters });
  }

  return (
    <AppContext.Provider value={{
      step: state.step,
      progress: state.progress,
      displayText: state.displayText,
      filters: state.filters,
      results: state.results,
      getResults,
      clearResults,
      getDisplayText,
      setStep,
      setProgress,
      setFilters
    }}>
      <App/>
    </AppContext.Provider>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <FindAProgram/>,
    document.getElementById('find-a-program')
  )
});